// @flow
// ref: https://chanind.github.io/javascript/2019/09/28/avoid-100vh-on-mobile-web.html
// ref: https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
import React from 'react';

const viewportContext = React.createContext({});

const MOBILE_WIDTH = 576;

export const ViewportProvider = ({ children }) => {
  const [width, setWidth] = React.useState(window.innerWidth);
  const [height, setHeight] = React.useState(window.innerHeight);
  const handleWindowResize = () => {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  };

  React.useEffect(() => {
    window.addEventListener('resize', handleWindowResize);
    return () => window.removeEventListener('resize', handleWindowResize);
  }, []);

  return (
    <viewportContext.Provider value={{ width, height }}>
      {children}
    </viewportContext.Provider>
  );
};

export const useViewport = () => {
  const { width, height } = React.useContext(viewportContext);
  const isMobile = width < MOBILE_WIDTH;
  return { width, height, isMobile };
};
